import React from 'react';

interface RiyalSymbolProps {
  className?: string;
  size?: number;
}

const RiyalSymbol: React.FC<RiyalSymbolProps> = ({ className = '', size = 20 }) => {
  return (
    <img 
      src="/images/Saudi_Riyal_Symbol.png" 
      alt="ر.س" 
      className={`riyal-symbol ${className}`}
      style={{ 
        width: size, 
        height: size, 
        display: 'inline-block',
        verticalAlign: 'middle',
        marginLeft: '5px'
      }}
    />
  );
};

export default RiyalSymbol;